import { render } from "./OceanCarrierNav.vue?vue&type=template&id=161eefbe&scoped=true"
import script from "./OceanCarrierNav.vue?vue&type=script&lang=js"
export * from "./OceanCarrierNav.vue?vue&type=script&lang=js"

import "./OceanCarrierNav.vue?vue&type=style&index=0&id=161eefbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161eefbe"]])

export default __exports__